module.exports = __webpack_public_path__ + "static/media/whistle.3a5b852a.wav";